import { Injectable, signal } from '@angular/core';

import { AssistantTableState } from '@core/models/assistant/assistant.model';

/**
 * Where `EntityComponent` publishes its checked rows for the assistant's page context. At most one
 * is alive at a time (the routed table, or the import picker on the plan page, which is not a data
 * page), so a single slot is enough.
 */
@Injectable({ providedIn: 'root' })
export class AssistantTableStateService {
  readonly state = signal<AssistantTableState | null>(null);
}
